import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/AuthService';
import { AuthSessionService } from 'src/app/core/services/AuthSessionService';
import { BrandingService } from 'src/app/core/services/branding.service';
import { UsuariosService } from 'src/app/core/services/usuarios.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './reset-mfa.component.html',
  styleUrls: ['./reset-mfa.component.scss']
})
export class ResetMFAComponent implements OnInit {

  mfaForm!: FormGroup;

  userName: string = 'Freddy Javier Amaya';
  secretKey: string = '';

  qrImage: string | null = null;

  loading: boolean = false;
  loadingQr: boolean = false;

  logoUrl: string | null = null;


  constructor(
    private fb: FormBuilder,
    private authService: AuthService , 
    private usuarioService: UsuariosService , 
    private router: Router,
    private brandingService: BrandingService , 
    private authSessionService: AuthSessionService,
    private location: Location
  ) {}

  async ngOnInit(): Promise<void> {

    this.mfaForm = this.fb.group({
      code: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{6}$/)
        ]
      ]
    });

    this.logoUrl =
      this.brandingService.getLogoUrl() ||
      "assets/images/dashboard/logo-oscuro.png";
    this.brandingService.settings$.subscribe(() => {
      this.logoUrl = this.brandingService.getLogoUrl();
    });

    await this.loadMFACode();
  }

  onLogoError(event: any) {
    if (!event.target.src.includes("logo-oscuro.png")) {
      event.target.src = "assets/images/dashboard/logo-claro.png";
    }
  }

  goBack(): void {
    this.authService.forceLocalLogout(true, 'manual');
    this.router.navigate(['/auth/login']);
  }

  async loadMFACode(): Promise<void> {

    try {

      this.loadingQr = true;

      const response = await this.authService.generateMFACode();

      this.qrImage = response.qrCodeUrl;
      this.secretKey = response.secret;

    } catch (error) {

      console.error('Error generando configuración MFA:', error);

    } finally {

      this.loadingQr = false;

    }
  }

  copySecret(): void {

    if (!this.secretKey) {
      return;
    }

    navigator.clipboard.writeText(this.secretKey);

  }

  async confirmMfa(): Promise<void> {

  if (this.mfaForm.invalid || this.loading) {
    this.mfaForm.markAllAsTouched();
    return;
  }

  const code = String(
    this.mfaForm.get('code')?.value ?? ''
  ).trim();

  try {

    this.loading = true;

    // 1. Validar código y habilitar MFA
    await this.authService.validateMFACode(code);

    // 2. Completar login MFA
    const loginResult: any =
      await this.authService.loginMFACode(code);

    if (!loginResult?.access_token?.trim()) {
      throw new Error(
        'No se recibió access_token al completar MFA'
      );
    }

    // 3. Crear sesión completa
    await this.authSessionService.completeLogin(
      loginResult.access_token
    );

  } catch (error) {

    console.error(
      'Error configurando MFA:',
      error
    );

  } finally {

    this.loading = false;

  }
}

  

}